/**
 * Hero Carousel
 */

// Import extend function.
import Component from '../../js/core/component.js';
import Carousel from '../carousel/c-carousel.js';
import getDataSettings from '../../js/utilities/get-data-settings/u-get-data-settings.js';
import '../../js/vendor/polyfills/polyfill-classlist.js';

class HeroCarousel extends Component {
	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false,
			classNames: {
				navigation: 'c-hero-carousel__nav',
				navigationList: 'c-hero-carousel__nav-list',
				navigationItem: 'c-hero-carousel__nav-item',
				navigationButton: 'c-hero-carousel__nav-button'
			}
		};
	}

	/**
	 * Initialize component
	 */
	_init () {
		this.element = this.settings.element;
		
		this.carousel = new Carousel({
			debug: false,
			element: this.element,
			buttons: false,
			navigation: false,
			on: {
				beforeSlide: (carousel) => {

					if (this.nav.querySelector('[aria-current]')) {
						this.nav.querySelector('[aria-current]').removeAttribute('aria-current');
					}

					let current = this.nav.querySelector('[data-slide="' + carousel.current + '"]');
					current.setAttribute('aria-current', 'true');
				}
			}
		});

		this.nav = document.createElement('div');
		this.nav.classList.add(this.settings.classNames.navigation);

		this.navList = document.createElement('ul');
		this.navList.classList.add(this.settings.classNames.navigationList);

		this.nav.appendChild(this.navList);

		this.carousel.items.forEach((item, i) => {
			let navItem = document.createElement('li');
			navItem.classList.add(this.settings.classNames.navigationItem);

			this.navList.appendChild(navItem);

			let button = document.createElement('button');
			button.classList.add(this.settings.classNames.navigationButton);
			button.setAttribute('type', 'button');
			button.setAttribute('data-slide', i);
			item.dataset.titleTrack ? button.dataset.trackClick = item.dataset.titleTrack : '';
			button.appendChild(document.createTextNode(item.getAttribute('data-title')));

			button.addEventListener('click', () => {
				this.carousel.gotoSlide(button.getAttribute('data-slide'));
			});

			navItem.appendChild(button);
		});

		this.carousel.init();

		this.element.appendChild(this.nav);
	}

}

document.addEventListener('newcontent', (e) => {
	e.target.querySelectorAll('.c-hero-carousel').forEach(element => {

		if (element.querySelector('ul').children.length <= 1) {
			return;
		}
		
		let settings = getDataSettings(element, {
			debug: true,
			element: element
		});

		element.heroCarousel = new HeroCarousel(settings);
	});
});

export default HeroCarousel;



// WEBPACK FOOTER //
// ./components/hero-carousel/c-hero-carousel.js